const IS_DEV = import.meta.env.MODE === "development";
export { IS_DEV };
export const ANIMATION_SPEED = 60;
export const DEV_HOST = "localhost";
// export const DEV_HOST = "192.168.0.9";
